import React, { useState, useMemo } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Stack,
  TextField,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Header1 from "../Header/Header1";
import Footer2 from "../Footer/Footer2";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import MailIcon from "@mui/icons-material/Mail";
import PostAddIcon from "@mui/icons-material/PostAdd";
import BookIcon from "@mui/icons-material/Book";
import { useAuth } from '../../AuthContext';
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import SchoolIcon from '@mui/icons-material/School';


const pages = [
  { name: "Invoice Management", path: "/invoice-list", roles: ["admin", "anthra-sales-executive"], icon: <MailIcon /> },
  { name: "Newsletter Subscriptions", path: "/news-letter-subscription-page", roles: ["admin", "anthra-sales-executive"], icon: <MailIcon /> },
  { name: "Post Review Panel", path: "/post-review-panel", roles: ["admin", "anthra-sales-executive"], icon: <PostAddIcon /> },
  { name: "Send Diwali Email", path: "/send-diwali-email-button", roles: ["admin"], icon: <MailIcon /> },
  { name: "Active Posts", path: "/active-posts", roles: ["admin", "anthra-sales-executive"], icon: <DashboardIcon /> },
  { name: "Create Accounts", path: "/admin-create-accounts", roles: ["admin", "anthra-sales-executive","ambassador","sales-partner-individual","sales-partner-company"], icon: <PeopleIcon /> },
  { name: "Create Employee", path: "/create-member", roles: ["admin", "anthra-sales-executive"], icon: <PeopleIcon /> },
  { name: "User Reservations", path: "/user-reservations", roles: ["admin", "anthra-sales-executive"], icon: <BookIcon /> },
  { name: "Expert Requests", path: "/admin-expert-requests", roles: ["admin", "anthra-sales-executive"], icon: <PeopleIcon /> },
  { name: "Ambassador Requests", path: "/admin-ambassador-requests", roles: ["admin", "anthra-sales-executive"], icon: <PeopleIcon /> },
  { name: "Sales Partner Dashboard", path: "/admin-sales-partner-dashboard", roles: ["admin", "anthra-sales-executive"], icon: <DashboardIcon /> },
  { name: "Active Post Bookings", path: "/active-post-bookings", roles: ["admin", "anthra-sales-executive"], icon: <BookIcon /> },
  { name: "Create Coupon", path: "/admin-create-coupon", roles: ["admin", "anthra-sales-executive"], icon: <MailIcon /> },
  { name: "User List View", path: "/user-list-view", roles: ["admin", "anthra-sales-executive"], icon: <PeopleIcon /> },
  { name: "Customer Queries Resolve", path: "/Customer-queries-resolve", roles: ["admin", "anthra-sales-executive"], icon: <MailIcon /> },
  { name: "FAQs", path: "/admin-faqs", roles: ["admin", "anthra-sales-executive"], icon: <DashboardIcon /> },
  { name: "Careers", path: "/admin-careers", roles: ["admin", "anthra-sales-executive"], icon: <DashboardIcon /> },
  { name: "Contact Us", path: "/admin-contact-us", roles: ["admin", "anthra-sales-executive"], icon: <MailIcon /> },
  { name: "Update Accounts", path: "/admin-update-accounts", roles: ["admin"], icon: <PeopleIcon /> },
  { name: "Update Posts", path: "/admin-update-posts", roles: ["admin"], icon: <PostAddIcon /> },
  { name: "Database Size Display", path: "/database-size-display", roles: ["admin"], icon: <DashboardIcon /> },
  { name: "Download Center", path: "/download-center", roles: ["admin", "anthra-sales-executive",], icon: <DashboardIcon /> },
  { name: "Download History", path: "/download-history", roles: ["admin"], icon: <DashboardIcon /> },
  { name: "All Requests", path: "/requests-page", roles: ["admin", "anthra-sales-executive",], icon: <DashboardIcon /> },
  { name: "AI Program", path: "/ai-program-admin-page", roles: ["admin", "anthra-sales-executive",], icon: <SchoolIcon /> },
  { name: "Enterprise AI", path: "/enterprise-ai-admin", roles: ["admin", "anthra-sales-executive",], icon: <SchoolIcon /> },
  {
  name: "All Appointments",
  path: "/admin-appointments",
  roles: ["admin","anthra-sales-executive"],
  icon: <BookIcon />
}
];


export default function AdminControlCenter() {
  const navigate = useNavigate();
  const { role, roles } = useAuth();
  const userRoles = Array.isArray(roles) && roles.length > 0 ? roles : [role];

  // Filter pages based on user's roles and sort alphabetically
  const accessiblePages = useMemo(() => {
    return pages
      .filter((page) => page.roles.some((r) => userRoles.includes(r)))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [userRoles]);

  // Search
  const [search, setSearch] = useState("");
  const filteredPages = useMemo(() => {
    return accessiblePages.filter((page) =>
      page.name.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, accessiblePages]);

  // Pagination
  const [page, setPage] = useState(0);
  const rowsPerPage = 6;
  const paginatedPages = filteredPages.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const totalPages = Math.ceil(filteredPages.length / rowsPerPage);

  return (
    <div style={{ backgroundColor: "#000000ff", minHeight: "100vh" }}>
      <Header1 />

      <Box sx={{ p: 4, maxWidth: "1200px", margin: "auto", color: "#e6edf3" }}>
        {/* Title */}
        <Typography
          variant="h4"
          fontWeight="bold"
          color="#58a6ff"
          mb={3}
          textAlign="center"
        >
          Admin Control Center
        </Typography>

        {/* Metrics & Search */}
       <Paper
  elevation={6}
  sx={{
    p: 3,
    mb: 4,
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: "space-between",
    alignItems: { xs: "flex-start", sm: "center" },
    backdropFilter: "blur(12px)",
    background: "rgba(20, 25, 35, 0.6)",
    border: "1px solid rgba(88,166,255,0.2)",
    borderRadius: "16px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
    transition: "all 0.3s",
    "&:hover": {
      boxShadow: "0 12px 36px rgba(88,166,255,0.5)",
      transform: "translateY(-2px)",
    },
  }}
>
  <Stack
    direction={{ xs: "column", sm: "row" }}
    spacing={2}
    alignItems={{ xs: "flex-start", sm: "center" }}
    width="100%"
  >
    {/* Metrics */}
    <Typography
      variant="body1"
      sx={{ color: "#58a6ff", fontWeight: 600 }}
    >
      Total Pages: <strong>{accessiblePages.length}</strong> | Filtered: <strong>{filteredPages.length}</strong>
    </Typography>

    {/* Search Bar */}
   <TextField
  label="Search Pages"
  variant="outlined"
  size="small"
  value={search}
  onChange={(e) => {
    setSearch(e.target.value);
    setPage(0);
  }}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <SearchIcon sx={{ color: "#58a6ff" }} />
      </InputAdornment>
    ),
  }}
  sx={{
    backgroundColor: "rgba(255,255,255,0.08)",
    borderRadius: "20px",
    "& .MuiInputBase-input": {
      color: "#e6edf3",
      padding: "10px 14px",
      fontWeight: 500,
    },
    "& .MuiInputLabel-root": { color: "#8b949e", fontWeight: 500 },
    "& .MuiOutlinedInput-root": {
      borderRadius: "20px",
      borderColor: "#30363d",
      boxShadow: "inset 0 2px 4px rgba(0,0,0,0.3)",
      transition: "all 0.3s ease",
      "&:hover": {
        borderColor: "#58a6ff",
        boxShadow: "0 0 10px rgba(88,166,255,0.3) inset",
      },
      "&.Mui-focused": {
        borderColor: "#58a6ff",
        boxShadow: "0 0 15px rgba(88,166,255,0.5) inset",
      },
    },
    flexGrow: 1,
  }}
/>
  </Stack>
</Paper>


        <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 3, // spacing between items
        justifyContent: 'center',
        mt: 5,
      }}
    >
      {paginatedPages.map((pageItem) => (
        <Paper
          key={pageItem.path}
          elevation={6}
          sx={{
            p: 3,
            borderRadius: '16px',
            background: 'linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.03))',
            backdropFilter: 'blur(12px)',
            border: '1px solid rgba(255,255,255,0.1)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '150px',
            width: { xs: '100%', sm: '45%', md: '30%' }, // responsive widths
            cursor: 'pointer',
            transition: 'all 0.3s',
            '&:hover': {
              transform: 'translateY(-5px)',
              boxShadow: '0 8px 20px rgba(88,166,255,0.4)',
            },
          }}
          onClick={() => navigate(pageItem.path)}
        >
          <Stack direction="column" alignItems="center" spacing={2}>
            <Box sx={{ fontSize: 40, color: '#58a6ff' }}>{pageItem.icon}</Box>
            <Typography
              variant="h6"
              fontWeight="bold"
              textAlign="center"
              sx={{ color: '#e6edf3' }}
            >
              {pageItem.name}
            </Typography>
          </Stack>
        </Paper>
      ))}
    </Box>

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <Stack direction="row" justifyContent="center" spacing={2} mt={4}>
            <Button
              variant="outlined"
              disabled={page === 0}
              onClick={() => setPage(page - 1)}
              sx={{ color: "#58a6ff", borderColor: "#30363d" }}
            >
              Previous
            </Button>
            <Typography align="center" sx={{ pt: 1 }}>
              Page {page + 1} of {totalPages}
            </Typography>
            <Button
              variant="outlined"
              disabled={page + 1 >= totalPages}
              onClick={() => setPage(page + 1)}
              sx={{ color: "#58a6ff", borderColor: "#30363d" }}
            >
              Next
            </Button>
          </Stack>
        )}
      </Box>

      <Footer2 />
    </div>
  );
}
